/* ==========================================================================
   Sindh Furniture — custom behaviour
   Scroll reveals · hero slider · product tabs · quick add · testimonials
   · parallax · counters · WhatsApp widget
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- helpers */
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function money(cents) {
    try {
      var f = (window.Shopify && window.Shopify.money_format) || '{{amount}}';
      return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* -------------------------------------------------------- scroll reveals */
  var revealObserver = null;

  function initReveals(root) {
    var items = $$('[data-sf-anim]', root).filter(function (el) {
      return !el.dataset.sfObserved;
    });
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('sf-in');
        el.dataset.sfObserved = '1';
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('sf-in');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    items.forEach(function (el) {
      el.dataset.sfObserved = '1';
      revealObserver.observe(el);
    });
  }

  /* -------------------------------------------------------------- counters */
  function initCounters(root) {
    var nodes = $$('[data-sf-count]', root).filter(function (el) {
      return !el.dataset.sfCounted;
    });
    if (!nodes.length) return;

    var run = function (el) {
      el.dataset.sfCounted = '1';
      var target = parseFloat(el.dataset.sfCount) || 0;
      var suffix = el.dataset.sfSuffix || '';
      if (reduceMotion) {
        el.textContent = target + suffix;
        return;
      }
      var start = performance.now();
      var dur = 1600;
      var step = function (now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(run);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            run(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  /* -------------------------------------------------------------- parallax */
  var parallaxNodes = [];
  function initParallax(root) {
    $$('[data-sf-parallax]', root).forEach(function (el) {
      if (parallaxNodes.indexOf(el) === -1) parallaxNodes.push(el);
    });
  }
  if (!reduceMotion) {
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;
          parallaxNodes.forEach(function (el) {
            var parent = el.parentElement;
            if (!parent) return;
            var r = parent.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) return;
            var speed = parseFloat(el.dataset.sfParallax) || 0.12;
            var offset = (r.top + r.height / 2 - vh / 2) * speed;
            el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
          });
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  /* ---------------------------------------------------------- hero slider */
  function initHero(root) {
    $$('[data-sf-hero]', root).forEach(function (hero) {
      if (hero.dataset.sfReady) return;
      hero.dataset.sfReady = '1';

      var slides = $$('.sf-hero__slide', hero);
      if (slides.length === 0) return;

      var dots = $$('.sf-hero__dot', hero);
      var index = Math.max(
        0,
        slides.findIndex(function (s) {
          return s.classList.contains('is-active');
        })
      );
      var speed = (parseFloat(hero.dataset.sfSpeed) || 5) * 1000;
      var autoplay = hero.dataset.sfAutoplay === 'true' && slides.length > 1 && !reduceMotion;
      var timer = null;

      function show(next) {
        if (next === index) return;
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          // restart the progress animation cleanly
          var fill = d.firstElementChild;
          d.classList.remove('is-active');
          if (fill) {
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
          }
          if (i === index) d.classList.add('is-active');
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function next() {
        show(index + 1);
      }
      function prev() {
        show(index - 1);
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(next, speed);
        hero.classList.remove('is-paused');
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
        hero.classList.add('is-paused');
      }

      var nextBtn = $('.sf-hero__arrow--next', hero);
      var prevBtn = $('.sf-hero__arrow--prev', hero);
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          next();
          start();
        });
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          prev();
          start();
        });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          show(i);
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });

      /* touch swipe */
      var startX = null;
      hero.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          stop();
        },
        { passive: true }
      );
      hero.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var diff = e.changedTouches[0].clientX - startX;
          if (Math.abs(diff) > 45) diff < 0 ? next() : prev();
          startX = null;
          start();
        },
        { passive: true }
      );

      /* keyboard */
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          next();
          start();
        }
        if (e.key === 'ArrowLeft') {
          prev();
          start();
        }
      });

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      if (dots[index]) dots[index].classList.add('is-active');
      start();
    });
  }

  /* ------------------------------------------------------- product filters */
  function initTabs(root) {
    $$('[data-sf-tabs]', root).forEach(function (wrap) {
      if (wrap.dataset.sfReady) return;
      wrap.dataset.sfReady = '1';

      var tabs = $$('.sf-tab', wrap);
      var grid = $('[data-sf-grid]', wrap);
      if (!grid) return;
      var cards = $$('.sf-card', grid);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.dataset.filter;
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });

          var shown = 0;
          cards.forEach(function (card) {
            var list = (card.dataset.collections || '').split(' ');
            var match = filter === '*' || list.indexOf(filter) !== -1;
            card.classList.toggle('is-hidden', !match);
            if (match) {
              shown++;
              card.classList.remove('sf-in');
              card.style.setProperty('--sf-delay', Math.min(shown * 45, 400) + 'ms');
              requestAnimationFrame(function () {
                card.classList.add('sf-in');
              });
            }
          });

          var empty = $('[data-sf-empty]', wrap);
          if (empty) empty.hidden = shown !== 0;
        });
      });
    });
  }

  /* ------------------------------------------------------------- quick add */
  function toast(html) {
    var old = $('.sf-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'sf-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = html;
    document.body.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () {
        el.remove();
      }, 400);
    }, 3600);
  }

  function initQuickAdd(root) {
    $$('[data-sf-add]', root).forEach(function (btn) {
      if (btn.dataset.sfReady) return;
      btn.dataset.sfReady = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.dataset.sfAdd;
        if (!id) return;

        btn.classList.add('is-loading');
        btn.disabled = true;

        fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw new Error(data.description || data.message || 'Error');
              return data;
            });
          })
          .then(function () {
            var cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
            toast(
              '<span>' +
                (btn.dataset.sfAddedText || 'Added to cart') +
                '</span><a href="' +
                cartUrl +
                '">' +
                (btn.dataset.sfViewText || 'View cart') +
                '</a>'
            );
            // let the theme know, if it is listening
            ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (name) {
              document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'sf-quick-add' } }));
            });
          })
          .catch(function (err) {
            toast('<span>' + (err.message || 'Could not add to cart') + '</span>');
          })
          .finally(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          });
      });
    });
  }

  /* ---------------------------------------------------------- testimonials */
  function initQuotes(root) {
    $$('[data-sf-quotes]', root).forEach(function (wrap) {
      if (wrap.dataset.sfReady) return;
      wrap.dataset.sfReady = '1';

      var track = $('.sf-quotes', wrap);
      if (!track) return;
      var prev = $('[data-sf-quotes-prev]', wrap);
      var next = $('[data-sf-quotes-next]', wrap);

      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 20 : 320;
      }

      if (next)
        next.addEventListener('click', function () {
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          }
        });

      if (prev)
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });

      if (wrap.dataset.sfAuto === 'true' && !reduceMotion) {
        var timer = setInterval(function () {
          if (document.hidden) return;
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          }
        }, parseInt(wrap.dataset.sfAutoSpeed || '4500', 10));

        wrap.addEventListener('mouseenter', function () {
          clearInterval(timer);
        });
      }
    });
  }

  /* ------------------------------------------------------ WhatsApp widget */
  function initWhatsApp(root) {
    $$('[data-sf-wa]', root).forEach(function (wa) {
      if (wa.dataset.sfReady) return;
      wa.dataset.sfReady = '1';

      var toggle = $('.sf-wa__toggle', wa);
      var panel = $('.sf-wa__panel', wa);
      var input = $('.sf-wa__input input', wa);
      var send = $('.sf-wa__send', wa);
      var body = $('.sf-wa__body', wa);
      var phone = (wa.dataset.sfPhone || '').replace(/[^0-9]/g, '');
      var bubble = $('.sf-wa__bubble', wa);
      var bubbleClose = $('.sf-wa__bubble-close', wa);

      function openLink(text) {
        if (!phone) return;
        var msg = text || (input && input.value) || wa.dataset.sfPrefill || 'Hello!';
        var ctx = wa.dataset.sfContext ? '\n\n' + wa.dataset.sfContext + ' ' + window.location.href : '';
        var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg + ctx);
        window.open(url, '_blank', 'noopener');
      }

      function setOpen(state) {
        wa.classList.toggle('is-open', state);
        if (toggle) toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
        if (state && body) {
          // simulate a short typing indicator the first time
          if (!wa.dataset.sfGreeted) {
            wa.dataset.sfGreeted = '1';
            var msgs = $$('.sf-wa__msg', body);
            if (msgs.length > 1) {
              var last = msgs[msgs.length - 1];
              last.style.display = 'none';
              var typing = document.createElement('div');
              typing.className = 'sf-wa__typing';
              typing.innerHTML = '<i></i><i></i><i></i>';
              body.appendChild(typing);
              setTimeout(function () {
                typing.remove();
                last.style.display = '';
                body.scrollTop = body.scrollHeight;
              }, 1100);
            }
          }
          setTimeout(function () {
            if (input) input.focus();
          }, 350);
        }
      }

      if (toggle)
        toggle.addEventListener('click', function () {
          if (!panel) {
            openLink();
            return;
          }
          setOpen(!wa.classList.contains('is-open'));
        });

      if (send)
        send.addEventListener('click', function () {
          openLink();
        });

      if (input)
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            openLink();
          }
        });

      $$('.sf-wa__chip', wa).forEach(function (chip) {
        chip.addEventListener('click', function () {
          openLink(chip.dataset.sfMessage || chip.textContent.trim());
        });
      });

      if (bubbleClose)
        bubbleClose.addEventListener('click', function (e) {
          e.stopPropagation();
          wa.classList.add('bubble-hidden');
          try {
            sessionStorage.setItem('sf-wa-bubble', 'hidden');
          } catch (err) {}
        });

      if (bubble) {
        var hidden = false;
        try {
          hidden = sessionStorage.getItem('sf-wa-bubble') === 'hidden';
        } catch (err) {}
        if (hidden) {
          wa.classList.add('bubble-hidden');
        } else {
          bubble.style.display = 'none';
          setTimeout(function () {
            if (!wa.classList.contains('is-open')) bubble.style.display = '';
          }, parseInt(wa.dataset.sfBubbleDelay || '2500', 10));
        }
      }

      document.addEventListener('click', function (e) {
        if (!wa.classList.contains('is-open')) return;
        if (wa.contains(e.target)) return;
        setOpen(false);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setOpen(false);
      });
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    root = root || document;
    initReveals(root);
    initCounters(root);
    initParallax(root);
    initHero(root);
    initTabs(root);
    initQuickAdd(root);
    initQuotes(root);
    initWhatsApp(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* Theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest ? e.target.closest('[data-sf-hero]') : null;
    if (!hero) return;
    var slides = $$('.sf-hero__slide', hero);
    var idx = slides.indexOf(e.target.closest('.sf-hero__slide'));
    if (idx > -1) {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      $$('.sf-hero__dot', hero).forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
  });

  window.SFTheme = { boot: boot, toast: toast, money: money };
})();

/* ==========================================================================
   v2 additions — countdown clock
   ========================================================================== */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdowns(root) {
    var nodes = (root || document).querySelectorAll('[data-sf-countdown]');
    Array.prototype.forEach.call(nodes, function (clock) {
      if (clock.dataset.sfReady) return;
      clock.dataset.sfReady = '1';

      var raw = (clock.dataset.sfCountdown || '').trim().replace(' ', 'T');
      var end = new Date(raw).getTime();
      if (isNaN(end)) {
        // try a plain date, then give up quietly
        end = new Date(clock.dataset.sfCountdown).getTime();
        if (isNaN(end)) return;
      }

      var d = clock.querySelector('[data-days]');
      var h = clock.querySelector('[data-hours]');
      var m = clock.querySelector('[data-minutes]');
      var s = clock.querySelector('[data-seconds]');

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          clock.innerHTML =
            '<div class="sf-clock__unit" style="min-width:auto;padding:14px 22px">' +
            (clock.dataset.sfEnded || 'This offer has ended') +
            '</div>';
          clearInterval(timer);
          return;
        }
        var secs = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(secs / 86400));
        if (h) h.textContent = pad(Math.floor((secs % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((secs % 3600) / 60));
        if (s) s.textContent = pad(secs % 60);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function run(root) {
    initCountdowns(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });
})();

/* ==========================================================================
   v5 — wishlist + quick view
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'sf-wishlist';

  function readList() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode — wishlist just won't persist */
    }
  }

  /* ------------------------------------------------------------- wishlist */
  function initWishlist(root) {
    var saved = readList();
    var buttons = (root || document).querySelectorAll('[data-sf-wish]');

    Array.prototype.forEach.call(buttons, function (btn) {
      var handle = btn.dataset.sfWish;
      if (saved.indexOf(handle) !== -1) {
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
      }
      if (btn.dataset.sfReady) return;
      btn.dataset.sfReady = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = readList();
        var i = list.indexOf(handle);
        if (i === -1) {
          list.push(handle);
          btn.classList.add('is-on');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          list.splice(i, 1);
          btn.classList.remove('is-on');
          btn.setAttribute('aria-pressed', 'false');
        }
        writeList(list);
        // keep every copy of this product in sync across the page
        Array.prototype.forEach.call(document.querySelectorAll('[data-sf-wish="' + handle + '"]'), function (other) {
          other.classList.toggle('is-on', list.indexOf(handle) !== -1);
        });
      });
    });
  }

  /* ----------------------------------------------------------- quick view */
  function money(cents) {
    if (window.SFTheme && window.SFTheme.money) return window.SFTheme.money(cents);
    return (cents / 100).toFixed(2);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function initQuickView(root) {
    var modal = document.querySelector('[data-sf-qv]');
    if (!modal) return;
    var content = modal.querySelector('.sf-qv__content');

    function close() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function open() {
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    if (!modal.dataset.sfReady) {
      modal.dataset.sfReady = '1';
      Array.prototype.forEach.call(modal.querySelectorAll('[data-sf-qv-close]'), function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
    }

    var triggers = (root || document).querySelectorAll('[data-sf-quick]');
    Array.prototype.forEach.call(triggers, function (btn) {
      if (btn.dataset.sfReady) return;
      btn.dataset.sfReady = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = btn.dataset.sfQuick;
        content.innerHTML = '<div class="sf-qv__loading">Loading…</div>';
        open();

        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('not found');
            return r.json();
          })
          .then(function (p) {
            var v = null;
            for (var i = 0; i < p.variants.length; i++) {
              if (p.variants[i].available) {
                v = p.variants[i];
                break;
              }
            }
            var single = p.variants.length === 1;
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var onSale = p.compare_at_price && p.compare_at_price > p.price;

            var actions = '';
            if (v && single) {
              actions +=
                '<button type="button" class="sf-btn" data-sf-add="' +
                v.id +
                '" data-sf-added-text="Added to cart" data-sf-view-text="View cart">Add to cart</button>';
            } else if (v) {
              actions += '<a href="/products/' + handle + '" class="sf-btn">Choose options</a>';
            } else {
              actions += '<span class="sf-btn" style="opacity:.5;pointer-events:none">Sold out</span>';
            }
            actions += '<a href="/products/' + handle + '" class="sf-btn sf-btn--ghost">View full details</a>';

            content.innerHTML =
              '<div class="sf-qv__media">' +
              (img ? '<img src="' + img + '" alt="' + esc(p.title) + '">' : '') +
              '</div>' +
              '<div class="sf-qv__body">' +
              '<h3 class="sf-qv__title">' + esc(p.title) + '</h3>' +
              '<div class="sf-qv__price"><span>' + money(p.price) + '</span>' +
              (onSale ? '<del>' + money(p.compare_at_price) + '</del>' : '') +
              '</div>' +
              '<div class="sf-qv__stock' + (v ? '' : ' sf-qv__stock--out') + '">' +
              (v ? '✓ In stock' : 'Currently sold out') +
              '</div>' +
              '<div class="sf-qv__desc">' + (p.description || '') + '</div>' +
              '<div class="sf-qv__actions">' + actions + '</div>' +
              '</div>';

            // the new Add to cart button needs wiring up
            if (window.SFTheme && window.SFTheme.boot) window.SFTheme.boot(content);
          })
          .catch(function () {
            content.innerHTML =
              '<div class="sf-qv__loading">Could not load this product. ' +
              '<a href="/products/' + handle + '">Open the product page</a></div>';
          });
      });
    });
  }

  function run(root) {
    initWishlist(root);
    initQuickView(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });
})();
